export default function LoadingIndicator() {
  return <div>Loading...</div>;
}
